"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevels = /** @class */ (function () {
    function LogLevels() {
    }
    LogLevels.DISABLED = { code: 0, name: "DISABLED", style: null };
    LogLevels.ERROR = { code: 1, name: "ERROR", style: 'background: #bc1601; color: #fafafa' };
    LogLevels.WARNING = { code: 2, name: "WARNING", style: 'background: #F6F35F; color: #1a1a1a' };
    LogLevels.INFO = { code: 3, name: "INFO", style: 'background: #BFE8A5; color: #1a1a1a' };
    LogLevels.DEBUG = { code: 4, name: "DEBUG", style: null };
    return LogLevels;
}());
exports.default = LogLevels;
//# sourceMappingURL=logLevel.js.map